module.exports = __webpack_public_path__ + "img/sycylia.f99cab5f.jpg";